import { attivita_lavorativa } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { DataGridTypes } from 'devextreme-react/cjs/data-grid'
import { SchedulerTypes } from 'devextreme-react/cjs/scheduler'
import { Duration } from 'luxon'

export const computeTempo = (tempo: string) => {
  if (tempo) {
    const durationOffice: Duration = Duration.fromISO(tempo)
    return new Date(0, 0, 0, durationOffice.hours, durationOffice.minutes)
  } else return new Date(0, 0, 0, 0, 0, 0)
}

export const calculateTempo = (options: DataGridTypes.CustomSummaryInfo) => {
  if (options.summaryProcess === 'start') {
    options.totalValue = options.name === 'TempoClienteUfficioTotale' ? { ore: 0, minuti: 0 } : 0
  }

  if (options.name === 'TempoTrasfertaTotale' && options.summaryProcess === 'calculate') {
    const row: attivita_lavorativa = options.value
    const duration: Duration = Duration.fromISO(row.tempo_trasferta)
    options.totalValue += duration.toMillis() / 3_600_000
  }

  if (options.name === 'TempoClienteUfficioTotale' && options.summaryProcess === 'calculate') {
    const row: attivita_lavorativa = options.value
    const durationClient: Duration = Duration.fromISO(row.tempo_cliente)
    const durationOffice: Duration = Duration.fromISO(row.tempo_ufficio)
    options.totalValue.minuti += durationClient.minutes
    options.totalValue.minuti += durationOffice.minutes
    options.totalValue.ore += durationClient.hours
    options.totalValue.ore += durationOffice.hours
    //calcolo i minuti tramutabili in ore
    const ore = Math.floor(options.totalValue.minuti / 60)
    const minuti = options.totalValue.minuti % 60
    if (ore > 0) {
      options.totalValue.ore += ore
      options.totalValue.minuti = minuti
    }
  }
}

function parseISODurationToMs(duration: string): number {
  const m = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/.exec(duration)
  if (!m) return 0
  const [_, h = '0', mi = '0', s = '0'] = m
  return parseInt(h, 10) * 3600_000 + parseInt(mi, 10) * 60_000 + parseInt(s, 10) * 1_000
}

export function convertAttivitaLavorativaToSchedulerAppointment(
  entries: attivita_lavorativa[],
): SchedulerTypes.Appointment[] {
  return (
    entries
      // 1) Filter out any with null data
      .filter((e): e is attivita_lavorativa & { data: string } => e.data !== null)
      .map((e) => {
        // now e.data is string
        const start = new Date(e.data)
        const totalMs =
          parseISODurationToMs(e.tempo_cliente) +
          parseISODurationToMs(e.tempo_trasferta) +
          parseISODurationToMs(e.tempo_ufficio)
        const end = new Date(start.getTime() + totalMs)

        return {
          // required Appointment fields
          startDate: start,
          endDate: end,
          text: e.ded_Dis,
          description: e.note ?? '',
          // optional
          allDay: false,
          // if you need to carry through the original id:
          // you can either extend Appointment or stash it in "data"
          // but DevExtreme also lets you pass "id":
          id: e.id,
        }
      })
  )
}
